import React from "react";
import Modal from "./Modal";
import { AlertTriangle } from "lucide-react";

const FailureModal = ({
  isOpen,
  onClose,
  errors,
  processedRows,
  totalRows,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Processing Issues"
      maxWidth="max-w-lg"
    >
      <div className="flex flex-col items-center py-4">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-4">
          <AlertTriangle className="h-10 w-10 text-amber-600" />
        </div>

        <h4 className="text-lg font-semibold text-amber-700 mb-2">
          Warning: Some Rows Failed
        </h4>

        <p className="text-blue-800 text-center mb-4">
          Processed {processedRows} of {totalRows} rows (
          {Math.round((processedRows / totalRows) * 100)}% complete)
        </p>

        <div className="bg-red-50 rounded-lg p-4 w-full mb-4">
          <h5 className="font-medium text-red-700 mb-3">
            {errors.length} error{errors.length > 1 ? "s" : ""} occurred:
          </h5>
          <div className="max-h-60 overflow-y-auto">
            <ul className="list-disc list-inside text-sm text-red-700 space-y-2">
              {errors.map((error, index) => (
                <li key={index} className="leading-tight">
                  {error.message}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-blue-300 text-sm font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FailureModal;
